<div class="container mt-6">
  <div
    class="flex items-center download-link-container"
    [formGroup]="downloadBillTypeForm"
  >
    <span class="icon-container h-full flex items-center download-link">
      <a
        class="pointer"
        data-automation="download-bill-hyperlink"
        (click)="downloadBillResults()"
      >
        <mat-icon
          svgIcon="download-new"
          class="header-icon stroke-primary"
        ></mat-icon>
        <span>
          {{ 'scenario.results.download_bill' | translate }}
        </span>
      </a>
    </span>
    <mat-form-field appearance="outline">
      <mat-label>
        {{ 'scenario.results.download_dispatch_profile_type' | translate }}
      </mat-label>
      <mat-select
        data-automation="download-bill-type"
        placeholder="{{ 'scenario.results.selected_bill_summary' | translate }}"
        (opened)="addCssForSelect()"
        (closed)="removeCssForSelect()"
        formControlName="downloadBillType"
      >
        <mat-option [value]="DOWNLOAD_TYPES.SUMMARY">
          {{ 'scenario.results.selected_bill_summary' | translate }}
        </mat-option>
        <mat-option [value]="DOWNLOAD_TYPES.DETAILED">
          {{ 'scenario.results.selected_bill_detail' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <table
    mat-table
    [dataSource]="dataSource"
    data-automation="multi-load-profile-table"
  >
    <ng-container
      *ngFor="let column of displayedColumns"
      [matColumnDef]="column"
    >
      <th mat-header-cell *matHeaderCellDef>
        {{ columns.get(column) | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let stat"
        [ngClass]="{ 'row-label': column === 'rowLabel' }"
      >
        <ng-container *ngIf="column === 'rowLabel'; else otherColumns">
          <span data-automation="multi-load-profile-table-row-label">
            {{ stat['rowLabel'] | translate }}
          </span>
        </ng-container>
        <ng-template #otherColumns>
          <span *ngIf="!units.get(column)">
            {{ stat[column] | currency: 'USD' : 'symbol' : '1.0-0' }}
          </span>
          <span *ngIf="units.get(column)">
            {{ stat[column] | number: '1.0-0' || '-' }}
          </span>
          <span class="ml-1">{{ units.get(column) | translate }}</span>
        </ng-template>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let stat; columns: displayedColumns"></tr>
  </table>
</div>
